const ROOT_TITLE = 'Pathfinder Authentication';

export { ROOT_TITLE };
